import { createElement } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { TFeaturePropertiesRequiredPrice } from 'shared/map-search/types/map';

import { SpecialPromo } from './SpecialPromo';

export const getSpecialPromoMarkup = ({
  specialPromo,
  minPrice,
  isActive,
  isHovered,
  isViewed,
}: TFeaturePropertiesRequiredPrice): string => {
  return renderToStaticMarkup(
    createElement(SpecialPromo, {
      specialPromo,
      minPrice,
      isActive,
      isHovered,
      isViewed,
    }),
  );
};
